define('jquery.popover',['jquery'], function ($) {

	/* jQuery Snappet Popovers v0.1.1 (based on Tooltips)
	 * Created by: Paul de Vries 6-6-2015
	 * 
	 * Call methods
	 * - $(element).popover("title", { optional: options });
	 * - $(element).popover({ options });
	 * 
	 * Options (object)
	 * - content [""] (string)
	 * - debug [true/false] (boolean)
	 * - placement "s" (string with [s/n/se/sw/ne/nw/e/w/en/es/wn/ws])
	 * - alternativePlacement (object)
	 *    - horizontal ["w", "e", "wn", "ws", "en", "es"] (array)
	 *    - vertical ["s", "n", "se", "sw", "ne", "nw"] (array)
	 *    - map (object)
	 *         - n ["s"]
	 *         - s ["n"]
	 *         - e ["w"]
	 *         - w ["e"]
	 * - viewport [window] (DOM element)
	 * - containment [true/false] (boolean)
	 * - closeOpenPopovers [true/false] (boolean)
	 * - closeOnClick [true/false] (boolean)
	 * - className ["popover"] (string)
	 * - appendTo ["body"] (string)
	 * - trigger ["click"] (string with "click" or "hover")
	 * - template ["<div>"] (string)
	 * - backdrop [false] (boolean)
	 * - delay (object)
	 *     - show [300] (number)
	 *     - hide [300] (number)
	 *     - resize [50] (number)
	 */

	var id = 0;
	var Popovers = function (options) {
		this.setOptions(options);
		this.options.placement = this.options.placement || "s";

		this.popover = $(this.options.template).addClass(this.options.className);
		this.popoverContainer = this.popover.find('.popover-container');
		this.popoverContent = this.popover.find('.popover-content');
		this.popoverLoader = this.popover.find('.popover-loader');
		this.popoverArrows = this.popover.find('.popover-arrow');

		this.hideTimeout;
		this.showTimeout;
		this.resizeTimeout;

		this.options.$elm.on("click.popover", this.watch.bind(this));
		this.options.$elm.on("remove.popover", this.destroy.bind(this));
		this.options.$elm.on("hide.popover", this.hide.bind(this));
		this.options.$elm.data("popover", this).addClass("isPopover");
		this.id = id;
		++id;

		if (this.options.backdrop) {
			this.backdrop = $('<div class="popover-backdrop"></div>');
		}
	};

	Popovers.prototype = {
		constructor: Popovers,
		backdrop: false,

		options: {
			debug: false,

			placement: "s",
			alternativePlacement: {
				horizontal: ["w", "e", "wn", "ws", "en", "es"],
				vertical: ["s", "n", "se", "sw", "ne", "nw"],
				result: [],
				map: {
					n: "s",
					s: "n",
					w: "e",
					e: "w"
				}
			},

			arrows: {
				map: {
					n: "top",
					s: "bottom",
					w: "left",
					e: "right"
				}
			},

			viewport: window,
			containment: true,
			closeOpenPopovers: true,
			closeOnClick: true,

			trigger: "click",

			hiddenClass: "hidden-calculations",
			disableDisabled: true,

			delay: {
				show: 300,
				hide: 300,
				resize: 51
			},

			appendTo: "body",
			className: "popover",
			template: '<div>' +
						'<div class="popover-container">' +
							'<div class="popover-arrow"></div>' +
							'<div class="popover-content"></div>' +
							'<div class="popover-loader"></div>' +
						'</div>' +
					'</div>'
		},

		show: function () {

			// When clicked, open the popover, when opening by hover add delay.
			if (this.options.trigger != "hover") {

				this._show.call(this);

			} else {

				if (this.showTimeout) {
					clearTimeout(this.showTimeout);
					this.showTimeout = null;
				}

				this.showTimeout = setTimeout(function () {
					if (this.options.$elm.is(":hover")) {
						this._show.call(this);
					}
					this.showTimeout = null;

				}.bind(this), this.options.delay.show);

				this.options.$elm.one("mouseleave", function () {
					clearTimeout(this.showTimeout);
					this.showTimeout = null;
				}.bind(this));

			}

		},

		_show: function (event) {
			var self = this;

			if (this.options.$elm.hasClass("openPopover") && event !== false) {
				self.hide();
				return;
			}

			if (!this.options.content) {

				if (this.options.debug) {
					console.warn("Popover: Stopping display of popover due to an empty content.");
				}

			} else if (this.options.disableDisabled && this.options.$elm.is(":disabled")) {

				if (this.options.debug) {
					console.warn("Popover: Stopping display of popover due to a disabled element.");
				}

			} else {

				// Get array of alternative placements
				this.options.alternativePlacement.result = this.placement.alternatives.call(this);

				// Close open popovers
				if (this.options.closeOpenPopovers) {
					$(".openPopover:not(.alwaysVisible)").trigger("hide.popover");
				}

				// Defined popover open
				this.options.$elm.addClass("openPopover");

				// Set content
				this.popoverContent.html('');
				var content = (typeof this.options.content === "function") ? this.options.content() : this.options.content;

				// Append to options.element
				this.popover.appendTo(this.options.appendTo).addClass(this.options.hiddenClass).attr("style", "");
				
				// Reposition popover
				this.reposition.call(this);

				// Display the popover
				this.popover.removeClass(this.options.hiddenClass);

				// Trigger event
				this.options.$elm.trigger("open.popover", this);

				// Hide by mouseover / hover
				if (this.options.trigger == "hover") {
					var $elms = this.popover.add(this.options.$elm);

					if (self.hideTimeout) {
						clearTimeout(self.hideTimeout);
						self.hideTimeout = null;
					}

					$elms.off(".timeout-popover")
						.on("mouseleave.timeout-popover", function () {

							if (self.hideTimeout) {
								clearTimeout(self.hideTimeout);
								self.hideTimeout = null;
							}

							self.hideTimeout = setTimeout(function () {
								self.hide();
								self.hideTimeout = null;
							}, self.options.delay.hide);

						})
						.on("mouseover.timeout-popover", function () {
							clearTimeout(self.hideTimeout);
							self.hideTimeout = null;
						});

				}

				// Close popovers on click
				if (this.options.closeOnClick) {
					this.popover.off("click.popover-by-click").on("click.popover-by-click", function (e) {
						if ($(e.target).prop("tagName") === "A" || ($(e.target).attr("data-bind") || "").indexOf("click") !== -1) {
							this.hide();
						}
					}.bind(this));
				}


				// Monitor window resize
				$(window).off("resize.popover" + self.id).on("resize.popover" + self.id, function () {
					if (self.resizeTimeout) {
						clearTimeout(self.resizeTimeout);
						self.resizeTimeout = null;
					}

					self.resizeTimeout = setTimeout(function () {
						self._show.call(self);
						self.resizeTimeout = null;
					}, self.options.delay.resize);
				});


				// Show backdrop
				if (this.options.backdrop && this.backdrop) {
					this.backdrop.appendTo('body');
				}
			}

		},

		setContent: function (string) {

			this.popoverContent.html(string);

		},

		reposition: function () {

			// Get placement
			var finalPlacement = this.placement.check.call(this, this.options.$elm[0]);

			// Apply CSS to placement result
			this.popover.css(finalPlacement.offset.result);

			// Apply CSS to arrows
			this.popoverArrows.attr("style", null);

			if (finalPlacement.placement[1]) {
				var alignment = this.options.arrows.map[finalPlacement.placement[1]];
				var position = this.options.arrows.map[finalPlacement.placement[0]];

				if (alignment === "top" || alignment === "bottom") {
					this.popoverArrows.css(alignment, (finalPlacement.offset.elm.height / 2));

					if (alignment === "bottom") {
						this.popoverArrows.css("top", "auto").css("bottom", parseFloat(this.popoverArrows.css("bottom")) - (parseFloat(this.popoverArrows.css("height")) / 2));
					}
				}
				if (alignment === "left" || alignment === "right") {
					if (finalPlacement.offset.elm.width > finalPlacement.offset.popover.width) {
						this.popoverArrows.css(alignment, (finalPlacement.offset.popover.width / 2));
					} else {
						this.popoverArrows.css(alignment, (finalPlacement.offset.elm.width / 2));
					}

					if (alignment === "right") {
						this.popoverArrows.css("left", "auto").css("right", parseFloat(this.popoverArrows.css("right")) - (parseFloat(this.popoverArrows.css("width")) / 2));
					}
				}

			}

		},

		watch: function () {

			// Move the function call to the end of the runtime (i.e. allow KO bindings to work first)
			setTimeout(function () {

				// If element has been disabled (e.g. no more mouseleave triggered)
				if (this.options.$elm.is(":disabled")) {
					this.hide.call(this);
				}

			}.bind(this), 0);

		},

		hide: function () {

			// Prevent popover from showing if it's scheduled
			if (this.showTimeout) {
				clearTimeout(this.showTimeout);
				this.showTimeout = null;
			}

			// Prevent popover from showing after closing
			if (this.resizeTimeout) {
				clearTimeout(this.resizeTimeout);
				this.resizeTimeout = null;
			}

			// Defined popover not open
			this.options.$elm.removeClass("openPopover");

			// Trigger event
			this.options.$elm.trigger("hidden.popover");

			// Remove tooltip
			this.popover.detach();

			// Remove events
			if (this.options.trigger == "hover") {
				clearTimeout(this.timeout);
				this.popover.add(this.options.$elm).off(".timeout-popover");
			}

			// Hide backdrop
			if (this.options.backdrop && this.backdrop) {
				this.backdrop.detach();
			}

			// Remove resize listereners
			$(window).off("resize.popover" + this.id);

		},

		destroy: function () {

			// Hide popover
			this.hide();

			// Remove events based on namespace
			this.options.$elm.off(".popover");

			// Remove data
			this.options.$elm.removeData("popover").removeClass("isPopover openPopover");

			// Trigger event
			$(document).trigger("destroy.popover", this);

		},

		dimensions: {

			horizontal: function (placement, dimension) {
				switch (placement) {
					case 'wn':
					case 'ws':
					case 'w':
						return this.get.start(dimension.elm.offset.left, dimension.popover.width);

					case 'en':
					case 'es':
					case 'e':
						return this.get.end(dimension.elm.offset.left, dimension.elm.width);

					case 'sw':
					case 'nw':
						return dimension.elm.offset.left;

					case 'se':
					case 'ne':
						return this.get.end(dimension.elm.offset.left, dimension.elm.width) - dimension.popover.width;

					default:
						return this.get.middle(dimension.elm.offset.left, dimension.elm.width, dimension.popover.width);

				}
			},

			vertical: function (placement, dimension) {
				switch (placement) {
					case 'nw':
					case 'ne':
					case 'n':
						return this.get.start(dimension.elm.offset.top, dimension.popover.height);

					case 'sw':
					case 'se':
					case 's':
						return this.get.end(dimension.elm.offset.top, dimension.elm.height);

					case 'wn':
					case 'en':
						return dimension.elm.offset.top;

					case 'ws':
					case 'es':
						return this.get.end(dimension.elm.offset.top, dimension.elm.height) - dimension.popover.height;

					default:
						return this.get.middle(dimension.elm.offset.top, dimension.elm.height, dimension.popover.height);

				}
			},

			get: {
				start: function (cord, dimension) {
					return cord - dimension;
				},
				end: function (cord, dimension) {
					return cord + dimension;
				},
				middle: function (cord, refDimension, popoverDimension) {
					return cord + ((refDimension / 2) - (popoverDimension / 2));
				}
			}

		},

		placement: {

			opposite: function (match, group1, group2) {
				if (group1 && group2) {
					return [
						group1.replace(group1, this.options.alternativePlacement.map[group1]) + group2,
						group1 + group2.replace(group2, this.options.alternativePlacement.map[group2])
					]
				} else {
					return [
						group1.replace(group1, this.options.alternativePlacement.map[group1])
					]
				}
			},

			alternatives: function () {
				var result;

				// Get a list of alternative placements, starting with opposite
				if (this.options.placement[0] === "s" || this.options.placement[0] === "n") {
					result = this.options.placement.replace(/(s|n)*(e|w)*/, this.placement.opposite.bind(this)).split(",");
					result = result.concat(this.options.alternativePlacement.vertical, this.options.alternativePlacement.horizontal);
				} else {
					result = this.options.placement.replace(/(e|w)*(s|n)*/, this.placement.opposite.bind(this)).split(",");
					result = result.concat(this.options.alternativePlacement.horizontal, this.options.alternativePlacement.vertical);
				}

				// Remove duplicates (remove later entries)
				return result.reduce(function (a, b) {
					if (a.indexOf(b) < 0) a.push(b);
					return a;
				}, []);

			},

			check: function (elm, placement, preventReplacement, stopReplacement) {

				// Use default placement or use the overwritten one
				placement = placement || this.options.placement;
				preventReplacement = preventReplacement || [].concat(this.options.alternativePlacement.result);

				// Unset and set arrow and styles for new calculations
				this.popover.attr("style", "").removeClass("n w e s nw ne sw se en es wn ws").addClass(placement);

				// Get basic offset and width/heights
				// Store getBoundingClientRect to a non-reference object (e.g. IE11)
				var dimension = {
					elm: $.extend({}, elm.getBoundingClientRect()),
					popover: $.extend({}, this.popover[0].getBoundingClientRect())
				}

				// Get correct relative offset
				dimension.elm.offset = {
					top: dimension.elm.top + $(window).scrollTop(),
					left: dimension.elm.left + $(window).scrollLeft()
				};

				// Prevent subpixels from generating incorrect width (e.g. IE9)
				dimension.popover.width = Math.ceil(dimension.popover.width);

				// Get top and left
				dimension.result = {
					top: this.dimensions.vertical(placement, dimension),
					left: this.dimensions.horizontal(placement, dimension)
				}

				if (this.options.debug) {
					console.debug("Positions", {
						elm: $.extend({}, dimension.elm),
						popover: $.extend({}, dimension.popover),
						result: $.extend({}, dimension.result)
					});
				}

				if (this.options.containment) {
					return this.placement.boundaries.call(this, dimension, elm, placement, preventReplacement, stopReplacement);
				} else {
					return dimension;
				}
			},

			boundaries: function (dimension, elm, placement, preventReplacement, stopReplacement) {

				// Overwrite position if it's outside the containment area
				if (!stopReplacement && preventReplacement.length > 0) {
					var viewport = {};

					// If viewport is window do not use getBoundingClientRect
					if (this.options.viewport !== window) {
						viewport = $(this.options.viewport)[0].getBoundingClientRect();
					} else {
						viewport = {
							left: $(this.options.viewport).scrollLeft(),
							top: $(this.options.viewport).scrollTop(),
							width: $(this.options.viewport).innerWidth(),
							height: $(this.options.viewport).innerHeight()
						}
					}

					// Check if popover position is outside the viewport; try using alternative position
					if (
						(dimension.result.left + dimension.popover.width > viewport.width + viewport.left) ||	// Right outside
						(dimension.result.left < viewport.left) ||	// Left outside
						(dimension.result.top + dimension.popover.height > viewport.height + viewport.top) ||	// Bottom outside
						(dimension.result.top < viewport.top)													// Top outside

					) {
						var newPlacement = preventReplacement.shift();

						if (this.options.debug) {
							console.debug("Popover: Placement '" + placement + "' did not fit, trying position '" + newPlacement + "'");
						}

						return this.placement.check.call(this, elm, newPlacement, preventReplacement);
					}

				} else if (!stopReplacement && preventReplacement.length === 0) {

					if (this.options.debug) {
						console.debug("Popover: Placement '" + placement + "' did not fit, using original position '" + this.options.placement + "'");
					}

					// No replacement found, use orignal placement
					return this.placement.check.call(this, elm, this.options.placement, [], true);
				}

				if (this.options.debug && !stopReplacement) {
					console.debug("Popover: Placement '" + placement + "' fits");
				}

				return {
					offset: dimension,
					placement: placement
				};

			},

		},

		showBy: function ($elm) {

			this.options.$elm = $elm;
			this._show();

		},

		// Overwrite options
		setOptions: function (options) {
			return this.options = $.extend({}, this.options, options);
		}

	};

	$.fn.popover = function () {
		var options = {};

		if (arguments.length > 1) {
			options = arguments[1];
			options.title = arguments[0] || "";
		} else if (typeof arguments[0] !== "string") {
			options = arguments[0] || {};
		} else {
			options.title = arguments[0] || "";
		}

		options.$elm = this;

		if (!options.$elm.data("popover")) {
			return new Popovers(options);
		} else {
			options.$elm.data("popover").setOptions(options);
			return options.$elm.data("popover");
		}
	};

	$.fn.popover.Constructor = Popovers;
	$.fn.popover.hideAll = function () {
		if (this.options.closeOpenPopovers) {
			$(".openPopover:not(.alwaysVisible)").trigger('hide.popover');
		}
	};

});
